import { styled } from '@mui/material';
import { blue } from '@mui/material/colors';
import { Box } from 'shared/mui/Box';
import { Typography } from 'shared/mui/Typography';
import { Datagrid } from 'shared/react-admin/Datagrids';

const defaultColumns = { width: 0 };

export const StyledCumulativeReportSummaryPeriod = styled('div')<{
  isOpen: boolean;
}>(({ theme, isOpen }) => ({
  width: '100%',
  height: '64px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  border: `1px solid ${theme.palette.divider}`,
  borderTopRightRadius: '4px',
  borderTopLeftRadius: '4px',
  borderBottomRightRadius: isOpen ? 0 : '4px',
  borderBottomLeftRadius: isOpen ? 0 : '4px',
  padding: '0 16px',
  backgroundColor: theme.palette.background.default,
}));

export const TypographyStyled = styled(Typography)({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  textDecoration: 'underline',
  color: blue[700],
  cursor: 'pointer',
  fontSize: '14px',
});

const columns = [
  'column-originalPaymentAmount',
  'column-originalPayoutAmount',
  'column-originalRefundAmount',
  'column-originalChargebackAmount',
  'column-originalCommissionPaymentValue',
  'column-originalCommissionPayoutValue',
  'column-originalCommissionRefundValue',
  'column-originalCommissionChargebackValue',
  'column-originalTotalAmount',
];

const thSelectors = columns.map((c) => `& th.${c}`).join(', ');
const tdSelectors = columns.map((c) => `& td.${c}`).join(', ');

export const DatagridStyled = styled(Datagrid)(({ theme }) => ({
  width: '100%',
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderBottomRightRadius: '4px',
  borderBottomLeftRadius: '4px',
  borderTop: 'none',
  borderTopRightRadius: 0,
  borderTopLeftRadius: 0,
  '& .MuiTableCell-root': {
    verticalAlign: 'middle!important',
  },
  '& .RaDatagrid-headerCell': {
    padding: '10px 16px',
  },
  '& .MuiTableCell-body': {
    verticalAlign: 'top',
    padding: '16px',
  },
  '& .MuiTableCell-head': {
    backgroundColor: theme.palette.tableHead,
  },
  '& .column-merchantAccountName': defaultColumns,
  '& .column-merchantAccountCurrencyCode': defaultColumns,

  [thSelectors]: {
    ...defaultColumns,
    textWrap: 'wrap',
    textAlign: 'right',
  },
  [tdSelectors]: {
    ...defaultColumns,
    textWrap: 'nowrap',
    textAlign: 'right',
  },
}));

export const BoxStyled = styled(Box)({
  marginBottom: '16px',
});
